import React from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  Stack,
} from '@mui/material';
import {
  ErrorBox,
  ErrorMessage,
  ErrorTitle,
  Fab,
} from '@marageti/z4-lib';
import { ViewProps } from './types';
import DestinationFilters from './destination-filters';
import DestinationItem from './destination-item';
import DestinationForm from './destination-form';

const DestinationsView = ({
  control,
  destinationsList,
  countryOptions,
  editorState,
  error,
  errors,
  filters,
  handleSubmit,
  onChangeNameFilter,
  onChangeCountryFilter,
  onChangeStatusFilter,
  onClickCreate,
  onClickEdit,
  onClose,
  onSubmit,
  register,
  showModal,
  submissionError,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box
      sx={{
        py: { desktop: 6.5, mobile: 4.5 },
        pb: { desktop: 6.5 + 10.5, mobile: 4.5 + 10.5 },
      }}
    >
      {error && (
        <ErrorBox>
          <ErrorTitle>There was an error on our end.</ErrorTitle>
          <ErrorMessage>{`Code: ${error.code}: ${error.message}`}</ErrorMessage>
        </ErrorBox>
      )}

      <DestinationFilters
        countryOptions={countryOptions}
        filters={filters}
        onChangeNameFilter={onChangeNameFilter}
        onChangeCountryFilter={onChangeCountryFilter}
        onChangeStatusFilter={onChangeStatusFilter}
      />

      {destinationsList && destinationsList.length === 0 ? (
        <Alert severity="info">
          <AlertTitle>There are no items to display.</AlertTitle>
        </Alert>
      ) : (
        <Stack spacing={1} marginBottom={2}>
          {destinationsList?.map((destination) => (
            <DestinationItem
              key={destination.id}
              destination={destination}
              onClickEdit={() => onClickEdit(destination)}
            />
          ))}
        </Stack>
      )}
    </Box>
    <Fab anchorId="oryx-footer">
      <Button
        variant="contained"
        sx={{
          minWidth: { mobile: '350px', desktop: 'fit-content' },
        }}
        onClick={onClickCreate}
      >
        New Destination
      </Button>
    </Fab>
    <DestinationForm
      control={control}
      countryOptions={countryOptions}
      editorState={editorState}
      errors={errors}
      handleSubmit={handleSubmit}
      onCancel={onClose}
      onSubmit={onSubmit}
      open={showModal}
      register={register}
      submissionError={submissionError}
    />
  </Container>
);

export default DestinationsView;
